module.exports = __webpack_public_path__ + "img/bmh_11.f1d39bf6.png";